<template>
  <div class="product-gallery-swiper">
    <div
      v-swiper-gallery
      class="swiper-container swiper-container--images">
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div
          v-for="(image, index) of images"
          :key="index"
          :style="'background-image:url(' + image.fields.file.url + '?w=700&fit=scale)'"
          class="swiper-slide">
        </div>
        <!-- Fine Slides -->
      </div>
      <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>

import swiper from './swiper'
export default {
  name: 'ProductGallerySwiper',
  mixins: [swiper],
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
